import React, { Component }  from 'react';
import './Alinhamento.css';
import inspiracao from '../../img/inspiracao.png';
import viva from '../../img/viva.png';
import impulso from '../../img/impulso.png';
import { Button } from 'react-bootstrap';


function Alinhamento() {
  return (
    <div>
      <ul className="list-group list-group-flush">
        <li className="list-group-item">
          <img src={inspiracao} id="inspiracao" alt="Inspiração" />
          <p className="explicacao">
            Programa que busca contribuir com a formação <br className="mobile-br" /> de crianças e adolescentes e jovens, por meio de <br className="mobile-br" /> atividades e iniciativas educacionais, que gerem <br className="mobile-br" /> oportunidades de desenvolvimento.
          </p>
        </li>
        <li className="list-group-item">
          <img src={viva} id="viva" alt="Viva" />
          <p className="explicacao">
            O Programa VIVA, Voluntariado Impactando Vidas <br className="mobile-br" /> e Ações, tem como foco estimular a participação <br className="mobile-br" /> de cooperados e colaboradores em iniciativas <br className="mobile-br" /> sociais estruturadas, buscando a tranformação <br className="mobile-br" /> da comunidade.
          </p>
        </li>
        <li className="list-group-item">
          <img src={impulso} id="impulso" alt="Impulso" />
          <p className="explicacao">
            Programa de incentivos fiscais e captação de <br className="mobile-br" /> recursos, que busca potencializar a força do <br className="mobile-br" /> investimento social coletivo, por meio do <br className="mobile-br" /> patrocínio de projetos culturais e esportivos.
          </p>
          <br className="mobile-br" />
          <Button href="/formulario" id="clique">
            CLIQUE AQUI E SAIBA COMO SEU <br className="mobile-br" /> PROJETO PODE SER PATROCINADO.
          </Button>
        </li>
      </ul>
    </div>
  );
}

export default Alinhamento;